// AI Activity Authoring — build-time backend capability flag.
//
// The AAA backend support (AdminGeneralUiSettings.showAiActivityAuthoring, the
// admin whitelist branch, and the Make-readable /api/flink-make/ai-authoring-settings
// endpoint) exists in source but is NOT YET DEPLOYED to the environment this build
// talks to. Until it is deployed, this stage must make ZERO requests to the new
// endpoint so that a UI landing on the old production backend causes NO new errors
// (no 404/401 noise, no console.error on every window focus).
//
// This is a FRONTEND-ONLY, build-time flag. It is intentionally a source constant
// (NOT read from an env file) and defaults to false. Flip it to true in the SAME
// deployment/PR that ships the backend support, so capability and backend move
// together. There is no runtime/local override — a human enables it by changing
// this constant when the backend is deployed.
//
// If, in future, the loaded server config exposes a real capability/version signal,
// this constant should be replaced by reading that signal instead.
//
// 2026-10-26: backend uploaded by the human, so capability is enabled. The Make
// endpoint now resolves on the real backend (fail-closed to enabled:false on any
// error, so an environment still lacking the route causes no button and no spam).
export const AI_AUTHORING_BACKEND_CAPABILITY = true;

export default AI_AUTHORING_BACKEND_CAPABILITY;
